module.exports = __webpack_public_path__ + "static/media/img_03.00176113.jpg";